import axiosInstance from "@/api/axiosInstance";
import { FetchWorkItemsParams, FetchWorkItemsResponse } from "./types";

export const fetchWorkItems = async (
  params?: FetchWorkItemsParams,
): Promise<FetchWorkItemsResponse> => {
  const queryParams = new URLSearchParams();

  if (params?.month) {
    queryParams.append("month", params.month);
  }
  if (params?.sprintId) {
    queryParams.append("sprintId", params.sprintId);
  }
  if (params?.page) {
    queryParams.append("page", params.page.toString());
  }
  if (params?.limit) {
    queryParams.append("limit", params.limit.toString());
  }

  const queryString = queryParams.toString();
  const url = `/api/capex/work-items${queryString ? `?${queryString}` : ""}`;

  const response = await axiosInstance.get<FetchWorkItemsResponse>(url);
  return response.data;
};
